import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import LeiService from '../../../../../services/leis-auth';
import { Link, Navigate, useParams } from 'react-router-dom';



const FormJornal = () => {
    const [jornal, setJornal] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([]);
    const { id } = useParams();

    async function fetchLei(id) {
        const response = await LeiService.leiEdit(id);
        setJornal(response.data["categoria"]);
    }

    useEffect(() => {
        fetchLei(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const lei = await LeiService.editar(id, {
                categoria: jornal
            })
            if (lei.data["cod_lei"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col lg={8}>
                                    <Form.Group className="mb-3" controlId="Categoria">
                                        <FloatingLabel
                                            label="Categoria"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="Categoria"
                                                name="categoria"
                                                onChange={e => setJornal(e.target.value)}
                                            >
                                                <option value={jornal}>{jornal}</option>
                                                <option value="Lei Municipal">Lei Municipal</option>
                                                <option value="Lei Tributária">Lei Tributária</option>
                                                <option value="Lei Orçamentária">Lei Orçamentária</option>
                                                <option value="Lei de Transparência">Lei de Transparência</option>
                                                <option value="Lei Orçamentária Anual - LOA">Lei Orçamentária Anual - LOA</option>
                                                <option value="Lei Orçamentária Plurianual - PPA">Lei Orçamentária Plurianual - PPA</option>
                                                <option value="Lei de Diretrizes Orçamentárias - LDO">Lei de Diretrizes Orçamentárias - LDO</option>
                                                <option value="Decreto">Decretos</option>
                                                <option value="Portaria">Portarias</option>
                                                <option value="Indicação">Indicações</option>
                                                <option value="Lei Ordinária">Lei Ordinária</option>
                                                <option value="Lei Complementar">Lei Complementar</option>
                                                <option value="Lei de Vigilância Sanitária">Lei de Vigilância Sanitária</option>
                                                <option value="Resolução">Resoluções</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={'/restrito/leis/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Lei editada com sucesso!</Alert>
                <Navigate to={'/restrito/leis/listar'} />
            </Fragment>
        )
    }
}

export default FormJornal